export default __webpack_public_path__ + "static/media/youtube-DarkBlue.d616dc39.png";